import { Subtitle, TexturedCircle } from 'themes/organic/components';
import { ContentContainer } from 'themes/organic/components/ContentContainer';

import s from './OrganicCancellationPolicySection.module.css';

export interface TProps {
  cancellationPolicy: string;
}

export const OrganicCancellationPolicySection = ({
  cancellationPolicy,
}: TProps) => {
  return (
    <section className={s.root}>
      <ContentContainer className={s.content}>
        <TexturedCircle className={s.texturedCircle} />
        <Subtitle>Cancellation Policy</Subtitle>
        <p className={s.text}>{cancellationPolicy}</p>
      </ContentContainer>
    </section>
  );
};
